export default __webpack_public_path__ + "static/media/etc03.9101c927.png";